module.exports = __webpack_public_path__ + "static/media/brands-07-el-corral@2x.a02f03d8.png";